import React, { Component } from 'react'
import PropTypes from 'prop-types'

import AssetForm from './forms/AssetForm'
import FormFieldsPerAssetType from './shared/FormFieldsPerAssetType'

export default class AddAsset extends Component {
  static propTypes = {
    assetTypes: PropTypes.object,
    authenticityToken: PropTypes.string,

    currencies: PropTypes.array,
    assetId: PropTypes.number,
    returnUrl: PropTypes.string,
    isRetired: PropTypes.bool,
    tenant: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state = {
      humanizedAssetTypes: this.props.assetTypes,
      authToken: this.props.authenticityToken,
      selectedAssetType: '',
      selectedAssetTypeVal: -1,
      showAssetMenu: true,
      currencies: this.props.currencies
    }
  }

  renderForm() {
    return this.buildAssetForm(this.state.selectedAssetType)
  }

  buildAssetForm(assetType) {
    return (
      <AssetForm
        assetName={assetType}
        authToken={this.state.authToken}
        methodType={'POST'}
        actionUrl={`/create_assets`}
        assetTypeVal={this.state.selectedAssetTypeVal}
        assetId={this.props.assetId}
        currencies={this.state.currencies}
        primeInterestRate={this.props.primeInterestRate}
        defaultMoneyMarketInterestRate={this.props.defaultMoneyMarketInterestRate}
        defaultOtherIncomeInterestRate={this.props.defaultOtherIncomeInterestRate}
        returnUrl={this.props.returnUrl}
        isRetired={this.props.isRetired} />
    )
  }

  render() {
    return (
      this.renderForm()
    )
  }
}
